import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { InsuranceService } from '../_services';
import * as InsuranceActions from '../_actions/insurance';

@Injectable({
  providedIn: 'root',
})
export class InsuranceEffects {
  loadInsurances$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceActions.loadInsurances),
      mergeMap(() =>
        this.insuranceService.getInsurances().pipe(
          map((insurances) => InsuranceActions.loadInsurancesSuccess({ insurances })),
          catchError((error) => of(InsuranceActions.loadInsurancesFailure({ error })))
        )
      )
    )
  );

  addInsurance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceActions.addInsurance),
      mergeMap(({ insurance }) =>
        this.insuranceService.saveInsurance(insurance).pipe(
          map((savedInsurance) =>
            InsuranceActions.addInsuranceSuccess({ insurance: savedInsurance })
          ),
          catchError((error) => of(InsuranceActions.addInsuranceFailure({ error })))
        )
      )
    )
  );

  updateInsurance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceActions.updateInsurance),
      mergeMap(({ insurance }) =>
        this.insuranceService.saveInsurance(insurance).pipe(
          map((updatedInsurance) =>
            InsuranceActions.updateInsuranceSuccess({ insurance: updatedInsurance })
          ),
          catchError((error) => of(InsuranceActions.updateInsuranceFailure({ error })))
        )
      )
    )
  );

  deleteInsurance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InsuranceActions.deleteInsurance),
      mergeMap(({ id }) =>
        this.insuranceService.deleteInsurance(id).pipe(
          map(() => InsuranceActions.deleteInsuranceSuccess({ id })),
          catchError((error) => of(InsuranceActions.deleteInsuranceFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private insuranceService: InsuranceService
  ) {}
}
